import {
  Tag,
  TagProps,
  Text,
  // SplitIcon,
  // LockIcon,
  // UnlockIcon,
  // HotIcon,
  FlexGap,
  FlexGapProps,
} from '@pancakeswap/uikit'
import Trans from 'components/Trans'
import { useTranslation } from '@pancakeswap/localization'
import { ReactNode, useMemo } from 'react'
import { DeserializedLockedVaultUser } from 'state/types'
import { VaultPosition, getVaultPosition } from 'utils/cakePool'
import styled from 'styled-components'

const tagConfig: Record<VaultPosition, TagProps> = {
  [VaultPosition.None]: {},
  [VaultPosition.Flexible]: {
    variant: 'success',
  },
  [VaultPosition.Locked]: {
    variant: 'warning',
  },
  [VaultPosition.LockedEnd]: {
    variant: 'secondary',
    outline: true,
  },
  [VaultPosition.AfterBurning]: {
    variant: 'failure',
    outline: true,
  },
}
// const iconConfig: Record<VaultPosition, any> = {
//   [VaultPosition.None]: null,
//   [VaultPosition.Flexible]: SplitIcon,
//   [VaultPosition.Locked]: LockIcon,
//   [VaultPosition.LockedEnd]: UnlockIcon,
//   [VaultPosition.AfterBurning]: HotIcon,
// }

const positionLabel: Record<VaultPosition, ReactNode> = {
  [VaultPosition.None]: '',
  [VaultPosition.Flexible]: <Trans>Flexible</Trans>,
  [VaultPosition.Locked]: <Trans>Locked</Trans>,
  [VaultPosition.LockedEnd]: <Trans>Locked End</Trans>,
  [VaultPosition.AfterBurning]: <Trans>After Burning</Trans>,
}

const StyledPosition = styled(Tag)`
  position: absolute;
  top: 0.6rem;
  right: 1.6rem;
  justify-content: center;
  box-sizing: content-box;
  width: 10em;
  transform: translate(50%,0) rotate(45deg);
`

const VaultPositionTag: React.FC<React.PropsWithChildren<{ position: VaultPosition }>> = ({ position }) => {
  // return (
  //   <Tag {...tagConfig[position]}>
  //     {/* <Box as={iconConfig[position]} mr="4px" /> */}
  //     <div style={{
  //       color:'rgb(0,255,0)',
  //     }}>
  //     {positionLabel[position]}
  //     </div>
  //   </Tag>
  // )
  return <StyledPosition {...tagConfig[position]}>{positionLabel[position]}</StyledPosition>
}

export const VaultPositionTagWithLabel: React.FC<
  React.PropsWithChildren<{ userData: DeserializedLockedVaultUser, mode?: string | "normal" } & FlexGapProps>
> = ({ userData, mode, ...props }) => {
  const { t } = useTranslation()

  const position = useMemo(() => getVaultPosition(userData), [userData])

  if (position) {
    return (
      mode==="normal" ?
      <FlexGap alignItems="center" justifyContent="space-between" marginX="8px" mb="8px" gap="12px" {...props}>
        <Text fontSize="12px" color="secondary" textTransform="uppercase" bold>
          {t('My Position')}
        </Text>
        <Tag {...tagConfig[position]}>
          <div style={{ color:'white' }}>
            {positionLabel[position]}
          </div>
        </Tag>
      </FlexGap> :
      <VaultPositionTag position={position} />
    )
  }

  return null
}
